export type PartnerOrganizationFormValues = {
  parentId: string;
  name: string;
  description: string;
  comments: string;
  acceptsGroups: boolean;
  acceptsEnglishSpeakers: boolean;
  logoImageId: string;
  maxGroupSize: string;
  operatingHours: string;
  isAccessible: boolean;
  cooperationLevel: number | "";
  dailyVolunteerTarget: string;
  handledBy: "CALL_CENTER" | "COORDINATORS" | "";
  handlingManagerId: string;
  nextFollowUpAt: string;
};

export const emptyPartnerOrganizationFormValues: PartnerOrganizationFormValues =
  {
    parentId: "",
    name: "",
    description: "",
    comments: "",
    acceptsGroups: false,
    acceptsEnglishSpeakers: false,
    logoImageId: "",
    maxGroupSize: "",
    operatingHours: "",
    isAccessible: false,
    cooperationLevel: "",
    dailyVolunteerTarget: "",
    handledBy: "",
    handlingManagerId: "",
    nextFollowUpAt: "",
  };
